import { Component, Input } from '@angular/core';
import { InvolvementCard } from '@models/condition.models';
import { CommonModule } from '@angular/common';
import { MarkdownPipe } from '@pipes/markdown.pipe';

@Component({
  selector: 'app-involvement-card',
  standalone: true,
  templateUrl: './involvement-card.component.html',
  styleUrls: ['./involvement-card.component.scss'],
  imports: [CommonModule, MarkdownPipe],
})
export class InvolvementCardComponent {
  @Input() card!: InvolvementCard;
  @Input() headingLevel: number = 3;
}
